module.exports = __webpack_public_path__ + "img/funeng.340d59ff.jpg";